/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetOrganizationsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetOrganizationsQuery = {
  __typename?: 'query_root';
  organizations: Array<{
    __typename?: 'organizations';
    id: string;
    name: string;
    description?: string | null;
    disabled: boolean;
    is_vendor_approval_workflows_enabled: boolean;
    is_risk_approval_workflows_enabled: boolean;
    is_vendors_module_enabled: boolean;
    parent_organization_id?: string | null;
    programs: Array<{ __typename?: 'programs'; id: string }>;
    organization_users_aggregate: {
      __typename?: 'organization_users_aggregate';
      aggregate?: { __typename?: 'organization_users_aggregate_fields'; count: number } | null;
    };
    programs_aggregate: {
      __typename?: 'programs_aggregate';
      aggregate?: { __typename?: 'programs_aggregate_fields'; count: number } | null;
    };
  }>;
};

export const GetOrganizationsDocument = `
    query GetOrganizations {
  organizations(order_by: {name: asc}) {
    id
    name
    description
    disabled
    programs {
      id
    }
    is_vendor_approval_workflows_enabled
    is_risk_approval_workflows_enabled
    is_vendors_module_enabled
    parent_organization_id
    organization_users_aggregate {
      aggregate {
        count
      }
    }
    programs_aggregate {
      aggregate {
        count
      }
    }
  }
}
    ` as string & TypedDocumentNode<GetOrganizationsQuery, GetOrganizationsQueryVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetOrganizations: build.query<GetOrganizationsQuery, GetOrganizationsQueryVariables | void>({
      query: (variables) => ({ document: GetOrganizationsDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetOrganizationsQuery, useLazyGetOrganizationsQuery } = injectedRtkApi;
